<div>
  <div fxLayout="row">
  </div>
</div>

<div *ngIf="isReady">
  <app-form-viewer-canvas [type]="'internal'"></app-form-viewer-canvas>
</div>
